import { useQuery } from '@tanstack/react-query';
import {
	documentWorkflowControllerFindDocumentWorkflowEventsOptions,
	documentWorkflowControllerFindDocumentWorkflowEventsQueryKey,
} from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';

// Shared so mutations that produce activity-log entries (assign, sign, claim, …)
// can invalidate the exact same key this query reads from — no key drift. The
// `deal-id` header is injected by the backend client interceptor, so only the
// path params are needed here.
export const getDocumentWorkflowEventsQueryKey = (params: {
	programmeId: string;
	documentWorkflowInstanceId: string;
}) => documentWorkflowControllerFindDocumentWorkflowEventsQueryKey({ path: params });

export const useDocumentWorkflowEvents = (options: {
	programmeId: string;
	documentWorkflowInstanceId: string;
}) => {
	const { programmeId, documentWorkflowInstanceId } = options;

	return useQuery({
		// Generated query options: structured key + a queryFn that unwraps the
		// { payload } envelope and throws on error.
		...documentWorkflowControllerFindDocumentWorkflowEventsOptions({
			path: { programmeId, documentWorkflowInstanceId },
		}),
		enabled: !!programmeId && !!documentWorkflowInstanceId,
	});
};
